module.exports = __webpack_public_path__ + "static/app-store-icon-google-6f93f0abb8258c31df891cb3ee8d71ee.png";